
import SingleProductElement from '../../components/product/single'
import { getCategorySortOptions, PRODUCT_SORT } from '../../constants/product-sort'
import { CATEGORY_GET_LIST_PRODUCT, INDEX_SET_LOADING } from '../../store/store.const'
import ShowMoreProduct from '@/components/product/showmore-product.vue'

export default {
  name: 'CategoryLevel1',
  components: { SingleProductElement, ShowMoreProduct },
  props: {
    category: {
      type: Object,
      required: true
    },
    collapseText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      slug: this.$route.params.slug,
      type_sort: PRODUCT_SORT.POPULAR,
      products: [],
      total: 0,
      page: 1,
      per_page: 23,
      last_page: 1,
      nextPage: true,
      toggleShowMore: true
    }
  },
  computed: {
    list_sort() {
      return getCategorySortOptions(key => this.$t(key))
    },
    hideFooter() {
      return this.$store.state.hideFooter
    }
  },
  watch: {
    type_sort() {
      this.page = 1
      this.products = []
      this.getListProduct()
    }
  },
  created() {
    this.getListProduct()
  },
  mounted() {},
  methods: {
    changeToLink(link) {
      this.$router.push(link)
    },
    async getListProduct() {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        const dataId = this.slug.split('.')
        const val = {
          page: this.page,
          per_page: this.per_page,
          order_by: this.type_sort
        }
        const products = await this.$store.dispatch(CATEGORY_GET_LIST_PRODUCT, { id: dataId[1], filters: val })
        if (!this.$device.isMobile) {
          if (this.products.length) this.products.push(...products.data.data)
          else this.products = products.data.data
          this.page = products.data.current_page
          this.last_page = products.data.total_page
          this.total = products.data.total
        } else {
          if (this.products.length) this.products.push(...products.data.data)
          else this.products = products.data.data
          this.page = products.data.data.length ? products.data.current_page : (this.page - 1)
          this.last_page = products.data.total_page
          this.total = products.data.total
        }
      } catch (e) {
        console.log(e)
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    },
    async changePage(page) {
      this.page = page
      await this.getListProduct()
    },
    clickShowMore(emit) {
      this.page = this.page + 1
      this.getListProduct()
    },
    toggleShowMoreFn() {
      this.toggleShowMore = !this.toggleShowMore
    }
  }
}
